var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4434C24.8366 32.4434 32 25.2799 32 16.4434C32 7.6068 24.8366 0.443359 16 0.443359C7.16344 0.443359 0 7.6068 0 16.4434C0 25.2799 7.16344 32.4434 16 32.4434Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0.443359C9.65628 0.443359 4.17528 4.13492 1.58728 9.48686H30.412C27.824 4.13492 22.343 0.443359 15.9997 0.443359V0.443359Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 32.4436C22.343 32.4436 27.824 28.7521 30.412 23.4001H1.58728C4.17528 28.7521 9.65628 32.4436 15.9997 32.4436Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.0085C19.0736 22.0085 21.5652 19.5169 21.5652 16.4433C21.5652 13.3698 19.0736 10.8781 16 10.8781C12.9264 10.8781 10.4348 13.3698 10.4348 16.4433C10.4348 19.5169 12.9264 22.0085 16 22.0085Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 19.9219C17.9213 19.9219 19.4786 18.3647 19.4786 16.4437C19.4786 14.5227 17.9213 12.9654 16.0003 12.9654C14.0794 12.9654 12.5221 14.5227 12.5221 16.4437C12.5221 18.3647 14.0794 19.9219 16.0003 19.9219Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 12.1511L17.0727 14.5847L19.7167 14.2971L18.1457 16.4432L19.7167 18.5893L17.0727 18.3017L15.9997 20.7353L14.9266 18.3017L12.2826 18.5892L13.8536 16.4432L12.2826 14.2971L14.9266 14.5847L15.9997 12.1511Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.73f4ffed.svg";
export { ForwardRef as ReactComponent };